@if (alert) {
  <ngb-alert [type]="alert.type" [dismissible]="true" (closed)="closeAlert()" class="mb-3">
    {{ alert.message }}
  </ngb-alert>
}

@if (isLoading) {
  <div class="d-flex justify-content-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
} @else {
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <!-- First Name -->
      <div class="col-md-6 mb-3">
        <label for="firstName" class="form-label">
          First Name
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          formControlName="firstName"
          [class.is-invalid]="getFieldError('firstName')"
          placeholder="Enter your first name" />
        @if (getFieldError('firstName')) {
          <div class="invalid-feedback">
            {{ getFieldError('firstName') }}
          </div>
        }
      </div>

      <!-- Last Name -->
      <div class="col-md-6 mb-3">
        <label for="lastName" class="form-label">
          Last Name
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          formControlName="lastName"
          [class.is-invalid]="getFieldError('lastName')"
          placeholder="Enter your last name" />
        @if (getFieldError('lastName')) {
          <div class="invalid-feedback">
            {{ getFieldError('lastName') }}
          </div>
        }
      </div>
    </div>

    <!-- Job Title -->
    <div class="mb-3">
      <label for="jobTitle" class="form-label">
        Job Title
        <span class="text-danger">*</span>
      </label>
      <input
        type="text"
        class="form-control"
        id="jobTitle"
        formControlName="jobTitle"
        [class.is-invalid]="getFieldError('jobTitle')"
        placeholder="Enter your job title" />
      @if (getFieldError('jobTitle')) {
        <div class="invalid-feedback">
          {{ getFieldError('jobTitle') }}
        </div>
      }
    </div>

    <!-- Department -->
    <div class="mb-3">
      <label for="department" class="form-label">
        Department
        <span class="text-danger">*</span>
      </label>
      <input
        type="text"
        class="form-control"
        id="department"
        formControlName="department"
        [class.is-invalid]="getFieldError('department')"
        placeholder="Enter your department" />
      @if (getFieldError('department')) {
        <div class="invalid-feedback">
          {{ getFieldError('department') }}
        </div>
      }
    </div>

    <!-- Interests -->
    @if (userInterests.length > 0) {
      <div class="mb-4">
        <div class="form-label fw-bold">Interests</div>
        <p class="text-muted small">Select topics that interest you (optional)</p>
        <div class="row">
          @for (interest of userInterests; track interest.id) {
            <div class="col-md-6 mb-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="'interest-' + interest.id"
                  [checked]="isInterestSelected(interest.id)"
                  (change)="onInterestChange(interest.id, $any($event.target).checked)" />
                <label class="form-check-label" [for]="'interest-' + interest.id">
                  {{ interest.name }}
                </label>
                @if (interest.description) {
                  <small class="text-muted d-block">{{ interest.description }}</small>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </form>
}
